export default __webpack_public_path__ + "static/media/ISKO_CLASS-5_SYLLABUS.9738fee4.pdf";